<template>
  <div class="selection-content">
    <div class="selection-form-container">
      <h3>Select Architecture</h3>
      <ul>
        <li
          v-for="(arc, index) in architectures"
          v-on:click="architectureSelected(arc)"
          :key="index"
          :class="{selected : isArchitectureSelected(arc), 'not-available' : !arc.available}"
        >
          <div>
            <p v-show="!arc.available" class="coming-soon">Coming soon</p>
            <h4 :class="{'not-available' : !arc.available}">{{ arc.name }}</h4>
            <p :class="{'not-available' : !arc.available}">{{ arc.description }}</p>
          </div>
        </li>
      </ul>
      <button v-if="hasSelectedArchitecture" v-on:click="navigateToAppDetails()">Next</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "SelectArchitectures",
  mounted(){
    this.setFooterState(1);
  },
  computed: {
    ...mapState(["architectures"]),
    ...mapGetters(["hasSelectedArchitecture", "isArchitectureSelected"])
  },
  methods: {
    ...mapActions(["setSelectedArchitecture", "setFooterState"]),
    architectureSelected(architecture) {
      this.setSelectedArchitecture(architecture);
    },
    navigateToAppDetails() {
      this.$router.push("app-details");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

.selection-content {
  display: grid;
}

$form-width: 520px;
$form-padding: 25px;

.selection-form-container {
  width: $form-width;
  height: fit-content;
  justify-self: center;
  background: $dark-grey-color;

  padding: $form-padding;
  display: grid;
  grid-template-rows: auto auto 50px;
  grid-row-gap: 10px;
  grid-template-areas:
    "title"
    "technologies"
    "next";
}

h3 {
  grid-area: title;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul {
  grid-area: technologies;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

li {
  display: block;
  border: 3px solid transparent;
  height: fit-content;
  transition: 0.3s;
}

li:hover:not(.not-available) {
  border: 3px solid $very-light-grey-color;
  border-radius: 5px;
}

li div {
  position: relative;
  display: block;
  width: 100%;
  height: fit-content;
  background: $dark-grey-color;
  background: $light-grey-color;
  border-radius: 5px;
  justify-self: center;
  padding: 20px;
  cursor: pointer;
}

button {
  grid-area: next;
  margin: 0 10px;
}
.coming-soon {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px 7px;
  background-color: $dark-grey-color;
  font-size: 15px;
  border-radius: 5px;
}

$architecture-size: 300px;

h1 {
  padding: 0;
  margin: 0;
  font-size: 65px;
  font-weight: 900;
  text-transform: uppercase;
}

h2 {
  padding: 0;
  margin: 0;
  margin-top: 100px;
  font-size: 40px;
  font-weight: 900;
  text-transform: uppercase;
  color: #343434;
}

h4 {
  margin: 0;
  padding: 0;
  font-weight: 800;
  font-size: 1.4em;
  text-align: start;

  grid-area: title;
}

.selected {
  border: 3px solid $primary-color;
  border-radius: 5px;

  text-align: left;
}

.selected:hover {
  border: 3px solid $primary-color;
}

.show {
  visibility: visible;
}

.hide {
  visibility: collapse;
}

.architectures {
  display: grid;
  grid-template-columns: repeat(4, auto);

  margin-top: 40px;
}

.architecture-item {
  width: $architecture-size;
  padding: 15px;
  background-color: $info-container-color;
  border-radius: 10px;

  display: grid;
  grid-template-areas:
    "image"
    "title";

  cursor: pointer;

  div {
    padding: 10px;
  }

  .coming-soon {
    background: #00000062;
    text-align: center;
    padding: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-radius: 5px;
    font-weight: 800;
    font-size: 20px;
    max-height: 70px;
    float: left;
  }
}
</style>